import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AjustedevaloresComponent } from './components/ajustedevalores/ajustedevalores.component';

const routes: Routes = [
  { path: 'ajustedevalores', component: AjustedevaloresComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AjustedevaloresRoutingModule { }
